import i18n from 'i18next';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { LogoLoadingScreen } from '@/components/loading/LogoLoadingScreen';
import { applyDocumentLocale, changeAppLanguage, isAppLocale } from '@/lib/i18n/documentLocale';

type Props = {
    children: React.ReactNode;
};

const LangSettings = ({ children }: Props) => {
    const lng = Cookies.get('i18next');
    const [ready, setReady] = useState(() => i18n.isInitialized);

    useEffect(() => {
        const handleReady = () => {
            setReady(true);
            applyDocumentLocale(i18n.language?.split('-')[0] || 'ar');
        };

        if (i18n.isInitialized) {
            handleReady();
        } else {
            i18n.on('initialized', handleReady);
        }

        const handleLanguageChanged = (language: string) => {
            applyDocumentLocale(language.split('-')[0] || language);
        };

        i18n.on('languageChanged', handleLanguageChanged);

        return () => {
            i18n.off('initialized', handleReady);
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, []);

    useEffect(() => {
        if (!isAppLocale(lng)) {
            void changeAppLanguage('ar');
            return;
        }
        applyDocumentLocale(lng);
    }, [lng]);

    if (!ready) {
        return <LogoLoadingScreen variant="fullscreen" />;
    }

    return <>{children}</>;
};

export default LangSettings;
